import "react-calendar/dist/Calendar.css"
import "./dateRangePicker.scss"

import { isAfter, isBefore, startOfDay } from "date-fns"
import PropTypes from "prop-types"
import React from "react"
import Calendar from "react-calendar"

export default function DateRangePicker({
  value,
  onChange,
  dateRange = true,
  minDate,
  maxDate,
  isPastDateDisabled = false
}) {
  const today = new Date()
  const todayStartOfDay = startOfDay(today)

  return (
    <Calendar
      onChange={onChange}
      value={value}
      selectRange={dateRange}
      showDoubleView={dateRange}
      className="date-range-filter"
      tileDisabled={({ date }) =>
        (minDate && isBefore(date, minDate.setHours(0, 0, 0, 0))) ||
        (maxDate && isAfter(date, maxDate.setHours(0, 0, 0, 0))) ||
        (isPastDateDisabled && date < todayStartOfDay)
      }
    />
  )
}

DateRangePicker.propTypes = {
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.array]),
  onChange: PropTypes.func,
  dateRange: PropTypes.bool,
  minDate: PropTypes.string,
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  isPastDateDisabled: PropTypes.bool
}
